import "react-toastify/dist/ReactToastify.css";

import React, { useEffect, useState } from "react";

import { CustomInput } from "../../../../../components/CustomInput/CustomInput";
import { useUser } from "../../../../../contexts/userContext";
import { usePatchUser } from "../../../../../hooks/reactQueryHooks/useUsers";
import { useDisableSubmit } from "../../../../../hooks/useDisableSubmit";
import { ReLoginUser } from "../../../../auth/components/AzureLogin";

const ProfileDetails: React.FC = () => {
  const { user, setUpdatedUser } = useUser();

  const { isDisabled, setInitialValue, onUpdateValues } = useDisableSubmit();

  const [formValues, setFormValues] = useState({
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
  });

  const patchUserMutation = usePatchUser();

  useEffect(() => {
    if (user) {
      setFormValues({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
      });
      setInitialValue({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
      });
    }
  }, [user, setInitialValue]);

  useEffect(() => {
    if (patchUserMutation.isSuccess) {
      ReLoginUser().catch(console.error);
      setUpdatedUser({
        firstName: formValues.firstName,
        lastName: formValues.lastName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patchUserMutation.isSuccess]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    onUpdateValues({
      ...formValues,
      [name]: value,
    });
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    patchUserMutation.mutate({
      userId: user?.sub || "",
      firstName: formValues.firstName,
      lastName: formValues.lastName,
    });
  };

  return (
    <div className="card mb-5 mb-xl-10">
      <div className="card-header border-0">
        <div className="card-title m-0">
          <h3 className="fw-bolder m-0">Profile details</h3>
        </div>
      </div>

      <hr className="mx-9 my-0" />

      <form onSubmit={handleSubmit} noValidate className="form">
        <div className="card-body p-9">
          <div className="row mb-6">
            <label className="col-lg-2 col-form-label fw-bold fs-6">
              First name:
            </label>
            <div className="col-lg-10">
              <div className="row">
                <div className="col-lg-6 fv-row">
                  <CustomInput
                    name="firstName"
                    placeholder="First name"
                    type="text"
                    handleChange={handleChange}
                    inputValue={formValues.firstName}
                    className="mt-n5"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-2 col-form-label fw-bold fs-6">
              Last name:
            </label>
            <div className="col-lg-10">
              <div className="row">
                <div className="col-lg-6 fv-row">
                  <CustomInput
                    name="lastName"
                    placeholder="Last name"
                    type="text"
                    handleChange={handleChange}
                    inputValue={formValues.lastName}
                    className="mt-n5"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-6">
            <label className="col-lg-2 col-form-label fw-bold fs-6">
              Email address:
            </label>

            <div className="col-lg-10 fv-row">
              <div className="row">
                <div className="col-lg-6 fv-row">
                  <CustomInput
                    name="email"
                    placeholder="Email address"
                    type="email"
                    inputValue={formValues.email}
                    className="mt-n5"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="mx-9 my-0" />
        <div className="card-footer d-flex justify-content-end py-6 px-9 border-0">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={patchUserMutation.isLoading || isDisabled}
          >
            {patchUserMutation.isLoading ? (
              <span className="indicator-progress" style={{ display: "block" }}>
                Please wait...{" "}
                <span className="spinner-border spinner-border-sm align-middle ms-2" />
              </span>
            ) : (
              <span>Save changes</span>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export { ProfileDetails };
